// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoMessage-module__ui-InfoMessage--GjL8Q {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 10px;
  border-radius: 12px;
  text-align: center;
  overflow-wrap: anywhere;
}

.InfoMessage-module__visual--nxA5n {
  color: var(--chaek-color-text-secondary);
  font-size: 22px;
  line-height: normal;
  letter-spacing: -0.26px;
}

.InfoMessage-module__title--nFOJM {
  color: var(--chaek-color-text-secondary);
  font-size: 12px;
  line-height: 19.2px;
}

.InfoMessage-module__content--SpyjQ {
  color: var(--chaek-color-text-source-333333);
  font-size: 10px;
  line-height: normal;
  letter-spacing: 0.1172px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/InfoMessage/InfoMessage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B","sourcesContent":[".ui-InfoMessage {\n  display: flex;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  padding: 10px;\n  border-radius: 12px;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.visual {\n  color: var(--chaek-color-text-secondary);\n  font-size: 22px;\n  line-height: normal;\n  letter-spacing: -0.26px;\n}\n\n.title {\n  color: var(--chaek-color-text-secondary);\n  font-size: 12px;\n  line-height: 19.2px;\n}\n\n.content {\n  color: var(--chaek-color-text-source-333333);\n  font-size: 10px;\n  line-height: normal;\n  letter-spacing: 0.1172px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-InfoMessage": `InfoMessage-module__ui-InfoMessage--GjL8Q`,
	"visual": `InfoMessage-module__visual--nxA5n`,
	"title": `InfoMessage-module__title--nFOJM`,
	"content": `InfoMessage-module__content--SpyjQ`
};
export default ___CSS_LOADER_EXPORT___;
